import { render, staticRenderFns } from "./OsSnackBar.vue?vue&type=template&id=287de135&scoped=true"
import script from "./OsSnackBar.vue?vue&type=script&lang=ts"
export * from "./OsSnackBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287de135",
  null
  
)

export default component.exports